import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    inject,
    Input,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import type { VisualizationType } from "../s25.opt.component";
import { TypeManagerDecorator } from "../../../main/type.map.service";

@TypeManagerDecorator("s25-ng-opt-visualization-buttons")
@Component({
    selector: "s25-ng-opt-visualization-buttons",
    template: `
        @if (hasList) {
            <button
                class="btn btn-default ngCompview"
                data-view="list"
                [ngClass]="{ 'btn-primary': selected === 'list' }"
                (click)="vizChange.emit('list')"
            >
                List
            </button>
        }
        @if (hasCalendar) {
            <button
                class="btn btn-default ngCompview"
                data-view="calendar"
                [ngClass]="{ 'btn-primary': selected === 'calendar' }"
                (click)="vizChange.emit('calendar')"
            >
                Calendar
            </button>
        }
        @if (hasAvailability) {
            <button
                class="btn btn-default ngCompview"
                data-view="availability"
                [ngClass]="{ 'btn-primary': selected === 'availability' }"
                (click)="vizChange.emit('availability')"
            >
                Availability
            </button>
        }
        @if (hasAvailabilityWeekly) {
            <button
                class="btn btn-default ngCompview"
                data-view="availabilityWeekly"
                [ngClass]="{ 'btn-primary': selected === 'availabilityWeekly' }"
                (click)="vizChange.emit('availabilityWeekly')"
            >
                Availability Weekly
            </button>
        }
    `,
    styles: `
        ::ng-deep .nm-party--on s25-ng-opt-visualization-buttons button {
            background-color: #28272c !important;
            border-color: rgba(255, 255, 255, 0.24) !important;
            color: white !important;
        }

        ::ng-deep .nm-party--on s25-ng-opt-visualization-buttons button:hover {
            color: #73b0e2 !important;
            border-color: #d7dadc !important;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25OptVisualizationButtonsComponent {
    @Input() hasList: boolean = false;
    @Input() hasCalendar: boolean = false;
    @Input() hasAvailability: boolean = false;
    @Input() hasAvailabilityWeekly: boolean = false;
    @Input() selected: VisualizationType;
    @Output() vizChange = new EventEmitter<VisualizationType>();

    private readonly elementRef = inject(ElementRef<HTMLElement>);

    /**
     * Focuses the view toggle button for the given tab.
     * Returns false when that button is not currently rendered.
     */
    focusViewButton(tab: VisualizationType): boolean {
        const button = this.elementRef.nativeElement.querySelector(
            `button[data-view="${tab}"]`,
        ) as HTMLButtonElement | null;
        if (!button) return false;

        button.focus();
        return true;
    }
}
